import {IState} from './RandomSampler.types';

export const initializeState:IState = {
    classes: [],
    manualImages: [],
    isErrorPage: false,
    isCleanClick: false,
    classIndex: -1,
    isAddClass: false,
    newClassInput: '',
    addClassError: '',
    globalClassError: '',
    imageNumber: -1,
    globalLoading: false,
    isShowAddToClassError: false,
    isRandomBtn: true,
    dataSource: '',
    dataTime: '',
    availableSources: [],
    batchId: -1,
    isDoneBatch: false,
    isEmpty: false,
    isImagesLoading: true
};

export const initializeStateJson = JSON.stringify(initializeState);
